var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C19.1046 8 20 7.10457 20 6C20 4.89543 19.1046 4 18 4C16.8954 4 16 4.89543 16 6C16 7.10457 16.8954 8 18 8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.07V19.5C11 19.78 11.22 20 11.5 20H12.9C13.03 20 13.16 19.95 13.25 19.85L19.08 14.02L16.96 11.9L11.15 17.71C11.05 17.81 11 17.94 11 18.07ZM12.03 14L14 12.03V12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14H12.03ZM20.85 11.56L19.44 10.15C19.24 9.95 18.93 9.95 18.73 10.15L17.67 11.21L19.79 13.33L20.85 12.27C21.05 12.07 21.05 11.76 20.85 11.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupButton);
export default __webpack_public_path__ + "static/media/signup-button.28c24feaf02cc944fc4e2ed0fb39af94.svg";
export { ForwardRef as ReactComponent };